import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { initBotId } from 'botid/client/core'
import App from './App.tsx'
import './index.css'

// Initialize BotID protection for form submissions and API endpoints
// Only protects POST requests - does NOT affect SEO or search engine crawlers
initBotId({
  protect: [
    // Add your protected endpoints here when you create them
    // Example: { path: '/api/contact', method: 'POST' }
    // Example: { path: '/api/booking', method: 'POST' }
  ],
});

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
